import {Json} from '../../../components/JsonObjectCard';
import {RequestExample} from '../../../components/RequestExampleCard';
import {RequestDefinitionData} from "../../../components/RequestDefinition";

const getShipmentRequest: RequestExample = {
    title: {
        verb: 'GET',
        endpointUrl: '/api/shipments/:id',
    },
    curl:
        `curl --location \\
--request GET '<YOUR SERVER>/api/shipments/:id' \\
--header 'Authorization: Bearer <TOKEN>'
`,
};

const getShipmentResponse: Json = {
    title: 'RESPONSE',
    json: {
        'id': 15,
        'number': 'S10024-01',
        'order': {
            'id': 21,
            'number': '10024',
            'type': 'SO'
        },
        'carrier': {
            'id': 4,
            'name': 'Fedex',
            'service': {
                'id': 8,
                'name': 'Ground'
            }
        },
        'fobPointName': 'Origin',
        'locationGroup': {
            'id': 2,
            'name': 'NY'
        },
        'lastModified': {
            'dateLastModified': '2026-01-26T03:56:09.052+00:00'
        },
        'shippedBy': 'admin',
        'dateCreated': '2026-01-26T03:55:50.689+00:00',
        'dateShipped': '2026-01-26T03:56:06.798+00:00',
        'note': '',
        'contact': 'Big Al\'s Bike Shop',
        'email': '',
        'phone': '801-932-1101',
        'billOfLading': '00000000000000154',
        'shipToAddress': {
            'name': 'Big Al\'s Bike Shop',
            'street': 'Big Al\'s Bike Shop',
            'city': 'Seattle',
            'state': 'WA',
            'postalCode': '98199',
            'country': 'UNITED STATES'
        },
        'status': 'Shipped',
        'cartons': [
            {
                'id': 15,
                'cartonNumber': 1,
                'trackingNumber': '',
                'freightWeight': '1,1',
                'freightWeightUom': {
                    'id': 3,
                    'name': 'Pound',
                    'abbreviation': 'lbs'
                },
                'freightAmount': '0',
                'sscc': '100000000000000151',
                'dateCreated': '2026-01-26T03:55:50.689+00:00',
                'width': '0',
                'height': '0',
                'length': '0',
                'sizeUom': {
                    'id': 7,
                    'name': 'Inch',
                    'abbreviation': 'in'
                },
                'insuredValue': '0',
                'shipperRelease': false,
                'additionalHandling': false,
                'shipItems': [
                    {
                        'id': 21,
                        'orderItemId': 43,
                        'product': {
                            'id': 37,
                            'name': 'ACB01',
                            'description': 'Accessories - Bike Bell'
                        },
                        'quantity': '1',
                        'uom': {
                            'id': 1,
                            'name': 'Each',
                            'abbreviation': 'ea'
                        },
                        'totalCost': '5.368421053'
                    },
                    {
                        'id': 22,
                        'orderItemId': 46,
                        'product': {
                            'id': 80,
                            'name': 'B202',
                            'description': 'Premium Brake Cables'
                        },
                        'quantity': '1',
                        'uom': {
                            'id': 1,
                            'name': 'Each',
                            'abbreviation': 'ea'
                        },
                        'totalCost': '9'
                    }
                ]
            }
        ],
        'customFields': [
            {
                'id': 21,
                'name': 'Custom',
                'value': 'Sample text value',
                'type': 'Text'
            }
        ]
    },
};

const data: RequestDefinitionData = {
    id: 'get-shipment',
    title: 'Get a shipment',
    description: 'Retrieves the details of an existing shipment. You only need to provide the unique shipment ID. Requires SHIP_VIEW access right.',
    endpoint: {
        verb: 'GET',
        path: '/shipments/:id',
        tooltip: 'Get a shipment',
    },
    attributes: [],
    requestObject: getShipmentRequest,
    responseObject: getShipmentResponse,
};

export default data;
